import Button from '@mui/material/Button'
import React from 'react'

type Props = {
  isSubmitDisabled: boolean
  backHandler: () => void
  submitHandler: () => void
}

const ContactsUploadCountriesActions: React.FC<Props> = ({ backHandler, submitHandler, isSubmitDisabled }) => (
  <>
    <Button variant="outlined" onClick={backHandler}>
      Back
    </Button>
    <Button
      id="contacts-upload-country-confirm"
      variant="contained"
      color="primary"
      disabled={isSubmitDisabled}
      onClick={submitHandler}
    >
      Next
    </Button>
  </>
)

export default ContactsUploadCountriesActions
